import { FC } from 'react';

export const SwapHorizon: FC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"></path>
  </svg>
);

export default SwapHorizon;
